import {get} from "../../../../../assets/js/shared/data-manager";
import moment from 'moment';

// Define the account property mapping
const ROLE_ACCOUNT_PROPERTY_MAPPING = {
    'firstName': 'firstName',
    'name': 'lastName',
    'email': 'email',
    'gender': 'gender',
    'birthDate': 'birthDate',
    'address[streetname]': 'streetName',
    'address[houseno]': 'streetNumber',
    'address[postalcode]': 'postalCode',
    'address[city]': 'city',
    'address[isocountry]': 'countryIso',
};

export default class FormWithAccountDefaults {
    constructor($form) {
        this.$form = $form;
        this.$roleControls = this.$form.querySelectorAll('[data-role]');

        this.handleAccountDefaults();
    }

    /**
     * get account data
     *
     * @return {Promise<*|undefined>}
     */
    async getAccountData() {
        return await get(`${placeholders.router.baseUri}/ajax-data/account/get`);
    }

    /**
     * handle account default
     *
     * @return {Promise<void>}
     */
    async handleAccountDefaults() {
        const account = await this.getAccountData();

        // If we don't have a account or it doesn't have properties we stop here
        if ( ! account || ! Object.keys(account).length) {
            return;
        }

        this.$roleControls.forEach($roleControl => this.setAccountDefault($roleControl, account));
    }


    /**
     * Set account default
     *
     * @param $roleControl
     * @param account
     */
    setAccountDefault($roleControl, account) {
        const role = $roleControl.dataset.role;

        const accountProperty = this.getAccountPropertyByRole(role);

        // Early return: Bail out if there is no mapped property
        // or if the account doesn't have a valid value for it.
        if (!accountProperty || account[accountProperty] === undefined || account[accountProperty] === null) {
            return;
        }

        // Format the value
        const formattedValue = this.formatPropertyValue(accountProperty, account[accountProperty]);

        // Handle specific input types (we can use early returns here too!)
        if ($roleControl.type === 'radio') {
            $roleControl.checked = ($roleControl.value === formattedValue);
            return;
        }

        if ($roleControl.type === 'checkbox') {
            $roleControl.checked = Boolean(formattedValue);
            return;
        }

        // Default fallback for text inputs, textareas, and selects
        $roleControl.value = formattedValue;
    }

    /**
     * Formats or transforms specific account properties (like gender)
     * @param {string} property
     * @param {*} value
     * @returns {*}
     */
    formatPropertyValue(property, value) {
        if (property === 'gender') {
            const genderMapping = {
                'M': 'Man',
                'F': 'Vrouw'
            };

            // Return mapped value, or the original value if it doesn't match M or V
            return genderMapping[value] ?? value;
        }

        if (property === 'birthDate') {
            const date = moment(value);
            // Ensure it's a valid date before formatting to 00/00/0000 (DD/MM/YYYY)
            // If invalid, fall back to the original value to avoid placing "Invalid date" in the input
            return date.isValid() ? date.format('DD/MM/YYYY') : value;
        }

        return value;
    }

    /**
     *
     * Get account property by role
     *
     * @param role
     * @return {*|null}
     */
    getAccountPropertyByRole(role) {
        return ROLE_ACCOUNT_PROPERTY_MAPPING[role] ?? null;
    }
}